export default __webpack_public_path__ + "images/H1.ec0eaf3.png";